import {IUserSessionData} from "api/model/user/IUserSessionData";
import {APIPromise} from "services/HttpService";
import {ApiDefinition} from "./ApiDefinition";


class UserStatisticsApiDefinition extends ApiDefinition {
    constructor() {
        super("/users/stats");
    }

    async getUsersSessions(dateFrom:string, dateTo:string, companyReference?: string, jobTitle?: string ): APIPromise<IUserSessionData[]> {
        return this.get(`sessions-range?from=${dateFrom}&to=${dateTo}${companyReference ? `&companyReference=${companyReference}` : `` }${jobTitle ? `&jobTitle=${jobTitle}` : `` }`);
    }

}

export const UserStatisticsApi = new UserStatisticsApiDefinition();